import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { IncludeJsService } from '../../services/include-js.service';
import { EnvironmentService } from '../../services/environment.service';

declare const QrScanner: any;

@Component({
    selector: 'app-pg-qrcode-scanner',
    templateUrl: './pg-qrcode-scanner.component.html',
    styleUrls: ['./pg-qrcode-scanner.component.scss'],
    standalone: false
})
export class PgQrcodeScannerComponent implements OnInit, AfterViewInit {

    constructor(private includeJsService:IncludeJsService, private environmentService:EnvironmentService) { }

    @Output() scan = new EventEmitter<string>()

    isLoading = false;

    ngOnInit(): void {

    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.initialize()
        }, 10)
    }

    qrScanner = null;

    @ViewChild('videoElement') videoElement:ElementRef
    
    initialize() {
        this.isLoading = true;

        this.includeJsService.include('assets/qr-scanner/qr-scanner.umd.min.js').then(() => {
            this.isLoading = false;

            this.qrScanner = new QrScanner(
                this.videoElement.nativeElement,
                (result) => {
                    console.log('QrcodeScanner scan', result)
                    this.scan.emit(result)
                }, 
                { returnDetailedScanResult: true },
            );

            this.qrScanner.start()
        })
    }
}
